/* global ol */

var angular = require('angular');
var PopperTooltip = require('tooltip.js');
var popperTooltipTemplate = require('html/templates/popperTooltip')();

var options = {
  template: popperTooltipTemplate,
  html: true,
  trigger: 'manual',
  placement: 'auto',
  delay: 400
};

function Tooltip(template, map) {
  this.template = template;

  options.container = document.body;

  this.overlay = new ol.Overlay({
    element: document.createElement('div')
  });

  this.interaction = new ol.interaction.Select({
    condition: ol.events.condition.pointerMove,
    toggleCondition: ol.events.condition.never,
    style: []
  });

  this.interaction.on('select', this.onSelect.bind(this));

  map.on('movestart', this.hideTooltip.bind(this)); // TODO disable tooltips until moveend
}

Tooltip.prototype.onSelect = function(event) {
  var selectedFeature = event.selected[0];

  clearTimeout(this.tooltipTimer);
  this.hideTooltip();

  if (selectedFeature && ol.events.condition.noModifierKeys(event.mapBrowserEvent)) {
    this.tooltipTimer = setTimeout(
      this.showTooltip.bind(this, selectedFeature),
      options.delay
    );
  }
};

Tooltip.prototype.hideTooltip = function() {
  if (this.tooltip) {
    this.tooltip.dispose();
    this.tooltip = null;
  }
};

Tooltip.prototype.showTooltip = function(selectedFeature) {
  if (selectedFeature && selectedFeature.getGeometry()) {
    this.overlay.setPosition(selectedFeature.getGeometry().getCoordinates());

    this.tooltip = new PopperTooltip(
      this.overlay.getElement(),
      angular.extend({ title: this.template.compile(selectedFeature) }, options)
    );

    this.tooltip.show();
  } else {
    console.log('showTooltip - Missing important args', selectedFeature);
  }
};

module.exports = Tooltip;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/tooltip.js
 ** module id = 192
 ** module chunks = 1
 **/